import SelectedContactComponent from '../dropDown/selectedContactComponent';
import classes from './budaAccordionComponent.scss';
import SetUpVoiceDropdown from '../../Common/dropDown/voiceDropDown';
import SetUpEmailDropdown from '../../Common/dropDown/emailDropdown';
import SetUpTextDropdown from '../../Common/dropDown/textDropdown';
import { getLocalizedStrings } from "../../../../centralizedLocalizedString";
class BUDAAccordionComponent extends React.Component {
    constructor(props) {
        super(props);
        this.strings = getLocalizedStrings('BaAlerts');
        this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
        this.disabledAddIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Disabled_Add.svg';
    }
    render() {
        const contactType = this.props.contactType;
        const accordianToggleStatus = this.props.stateData.accordianToggleStatus[contactType];
        return (
            <div className={classes.cppAccordionComponent}>
                <div>
                    {this.props.stateData.addContactLimitArr[contactType] > 0 ?
                        <div className={classes.Fragment}>
                            <SelectedContactComponent
                                contactType={contactType}
                                contactMethodIndex={0}
                                dropdownDiffererentiator={'One'}
                                addContactValueArr={this.props.stateData.addContactValueArr}
                                onContactMethodCheckHandler={this.props.onContactMethodCheckHandler}
                                addContactCheckedStatusArr={this.props.stateData.addContactCheckedStatusArr}
                                onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                onSelectDropDown={this.props.onSelectDropDown}
                                isSameValueSelectError={this.props.stateData.isSameValueSelectError}
                                dropDownData={this.props.dropDownData}
                                addContactEncValueArr={this.props.addContactEncValueArr}
                            />
                        </div> : null}
                    {this.props.stateData.addContactLimitArr[contactType] > 1 ?
                        <SelectedContactComponent
                            contactType={contactType}
                            contactMethodIndex={1}
                            dropdownDiffererentiator={'Two'}
                            addContactValueArr={this.props.stateData.addContactValueArr}
                            onContactMethodCheckHandler={this.props.onContactMethodCheckHandler}
                            addContactCheckedStatusArr={this.props.stateData.addContactCheckedStatusArr}
                            onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                            onSelectDropDown={this.props.onSelectDropDown}
                            isSameValueSelectError={this.props.stateData.isSameValueSelectError}
                            dropDownData={this.props.dropDownData}
                            addContactEncValueArr={this.props.addContactEncValueArr}
                        /> : null}
                    {this.props.stateData.addContactLimitArr[contactType] > 2 ?
                        <SelectedContactComponent
                            contactType={contactType}
                            contactMethodIndex={2}
                            dropdownDiffererentiator={'Three'}
                            addContactValueArr={this.props.stateData.addContactValueArr}
                            onContactMethodCheckHandler={this.props.onContactMethodCheckHandler}
                            addContactCheckedStatusArr={this.props.stateData.addContactCheckedStatusArr}
                            onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                            onSelectDropDown={this.props.onSelectDropDown}
                            isSameValueSelectError={this.props.stateData.isSameValueSelectError}
                            dropDownData={this.props.dropDownData}
                            addContactEncValueArr={this.props.addContactEncValueArr}
                        /> : null}
                    {!this.props.stateData.addContactToggleStatus[contactType] ?
                        <div className={classes.sceAddButtonContainer + ' row'} >
                            <button
                                className={this.props.stateData.addContactLimitArr[contactType] === 3 ? classes.sceCPPAddButtonDisabled : classes.sceCPPAddButton} disabled={this.props.stateData.addContactLimitArr[contactType] === 3}
                                onClick={() => this.props.onAddContactClickHandler(contactType)}>
                                {(this.props.stateData.addContactLimitArr[contactType] === 3) ? null : <div><img className={classes.addIcon} src={this.addIcon} alt="Add Icon" />
                                <span className={classes.addBtnTxt}>{this.props.addContactButtonText}</span></div>}
                            </button>
                        </div> : null
                    }

                    {(this.props.stateData.addContactToggleStatus[contactType]) ?
                        contactType === 'email' ?
                            <div className={classes.sceTextBoxData}>
                                <SetUpEmailDropdown
                                    triggerOnClick={() => this.props.onAddContactCancelHandler(contactType)}
                                    onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                    id={contactType}
                                    dropdownDiffererentiator={'Zero'}
                                    onSelectDropDown={(e) => this.props.onSelectDropDown(e)}
                                    isSameValueError={false}
                                    dropDownData={this.props.dropDownData}
                                    inputButtonText={this.strings.addBtnName}
                                    addContactValueArr={this.props.addContactValueArr}
                                    addContactEncValueArr={this.props.addContactEncValueArr}
                                />
                            </div>
                            :
                            contactType === 'voice' ?
                                <div className={classes.sceTextBoxData}>
                                    <SetUpVoiceDropdown
                                        triggerOnClick={() => this.props.onAddContactCancelHandler(contactType)}
                                        onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                        id={contactType}
                                        dropdownDiffererentiator={'Zero'}
                                        onSelectDropDown={(e) => this.props.onSelectDropDown(e)}
                                        isSameValueError={false}
                                        dropDownData={this.props.dropDownData}
                                        inputButtonText={this.strings.addBtnName}
                                        addContactValueArr={this.props.addContactValueArr}
                                        addContactEncValueArr={this.props.addContactEncValueArr}
                                    />
                                </div>
                                :
                                <div className={classes.sceTextBoxData}>
                                    <SetUpTextDropdown
                                        triggerOnClick={() => this.props.onAddContactCancelHandler(contactType)}
                                        onModifyCustomerPreference={this.props.onModifyCustomerPreference}
                                        id={contactType}
                                        dropdownDiffererentiator={'Zero'}
                                        onSelectDropDown={(e) => this.props.onSelectDropDown(e)}
                                        isSameValueError={false}
                                        dropDownData={this.props.dropDownData}
                                        inputButtonText={this.strings.addBtnName}
                                        addContactValueArr={this.props.addContactValueArr}
                                        addContactEncValueArr={this.props.addContactEncValueArr}
                                    />
                                </div>
                        : null}
                </div>
            </div>
        );
    }
}

export default BUDAAccordionComponent;
